/**
 * 计算文本“字符数”
 * 计数规则：
 * - 中文字符、日韩文、CJK标点、全角字符：每个计 2
 * - 英文字符、数字、半角标点、空格：每个计 1
 */
export function getWordCount(text: string): number {
  if (!text) return 0;
  let count = 0;

  // 使用 for...of 自动处理 Unicode 代理对 (等同于 Dart 的 runes)
  for (const char of text) {
    const code = char.codePointAt(0);
    if (code === undefined) continue;

    if (_isHalfWithForms(code)) {
      count += 1;
    } else if (_isCJKOrFullWith(code)) {
      count += 2;
    } else {
      count += 1;
    }
  }
  return count;
}

/**
 * 按指定最大权重截断字符串
 */
export function trimToWordCount(text: string, maxCount: number): string {
  if (maxCount <= 0 || !text) return '';

  let count = 0;
  let result = '';

  for (const char of text) {
    const code = char.codePointAt(0);
    if (code === undefined) break;

    const w = _isHalfWithForms(code) ? 1 : (_isCJKOrFullWith(code) ? 2 : 1);

    if (count + w > maxCount) break;

    result += char;
    count += w;
  }
  return result;
}

/**
 * 是否为“半角”字符
 */
function _isHalfWithForms(c: number): boolean {
  return (c >= 0xFF61 && c <= 0xFF9F) || (c >= 0xFFE8 && c <= 0xFFEE);
}

/**
 * 是否为 CJK 或“全角”字符
 */
function _isCJKOrFullWith(c: number): boolean {
  if ((c >= 0x3400 && c <= 0x4DBF) || (c >= 0x4E00 && c <= 0x9FFF)) return true;
  if (c >= 0x20000 && c <= 0x2FA1F) return true;
  if ((c >= 0x3040 && c <= 0x30FF) || (c >= 0xAC00 && c <= 0xD7AF)) return true;
  if (c >= 0x3000 && c <= 0x303F) return true;
  if ((c >= 0xFF01 && c <= 0xFF60) || (c >= 0xFFE0 && c <= 0xFFE6)) return true;
  return false;
}